import { notifyComponentLoaded } from "@hzero-front-ui/core/lib/utils/dynamicLoad";
import "../Tooltip/css";
notifyComponentLoaded("hzero-ui::upload");